import {useQuery} from 'react-query';
import EmployeesApiService from '@/modules/employees/services/EmployeesApiService';

export const useGetWorkers = (filters) => {
  const {isLoading, isError, error, data} = useQuery(['search-workers', filters], async () => {
    const {data} = await EmployeesApiService.search({size: 250, filters});
    return data;
  });
  return {isLoading, isError, error, data};
};
